import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  standalone: true,
  selector: 'search-navtop',
  imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
  templateUrl: './search-navtop.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class searchNavtopAtom implements OnInit {
  @Input() faIcon = faSearch;
  @Input() placeholder = 'Nhập tìm kiếm';
  @Input() control = new FormControl();
  @Input() id = 'search-topnav';
  @Output() searchEvent = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}
}
